import React from 'react';
import {withRouter} from 'react-router-dom';
import { Toolbar } from 'react-onsenui';
import _ from 'lodash';

const Header = props => {
    return (
        <Toolbar modifier='material'>
            <div className="left"></div>
            <div className="center common">
                <div style={{textTransform: 'uppercase', fontWeight: '700'}} className='center-align'>{props.title}</div>
            </div>
            <div className="right common">
                <div style={{textAlign: 'left', color: '#df4e46'}} onClick={() => {
                    if(_.isFunction(props.previousStep)) {
                        props.previousStep();
                    }
                    else {
                        props.history.goBack();
                    }
                }}>Annuler</div>
            </div>
        </Toolbar>
    );
}

export default withRouter(Header);